// services/login.js
import axiosInstance, { getCookie } from './axiosInstance';

const loginService = {
  /**
   * Validate session by calling login endpoint with existing token
   * Uses the axios middleware for proper authentication handling
   */
  async validateSession() {
    try {
      // Get token for validation
      const token = getCookie('token_js') || getCookie('token') || localStorage.getItem('token');
      
      const response = await axiosInstance.post('/login.php', {
        token: token  // Send token in body for validation
      });
      return response.data;
    } catch (error) {
      console.error('Session validation error:', error);
      throw error;
    }
  },

  /**
   * Login with username and password
   */
  async login(username, password) {
    try {
      const response = await axiosInstance.post('/login.php', {
        uname: username,
        upass: password
      });
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  }
};

export default loginService;
